import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Row, Col, Badge } from "react-bootstrap";
import { CommonInput, CommonSelect, CommonButton } from "../Input";
import DataTable from "../table/DataTable";
import IndividualCustomerModal from "./IndividualCustomerModal";
import OrganizationCustomerModal from "./OrganizationCustomerModal";
// Import removed as we navigate to a separate page now
// import CustomerDetailsModal from "./CustomerDetailsModal";

const CustomerList = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [name, setName] = useState("");
  const [idCard, setIdCard] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [nationality, setNationality] = useState(null);
  const [walletBalance, setWalletBalance] = useState(null);
  const [customerType, setCustomerType] = useState(null);
  const [showIndividualModal, setShowIndividualModal] = useState(false);
  const [showOrganizationModal, setShowOrganizationModal] = useState(false);

  const nationalityOptions = [
    { value: "vietnam", label: "Vietnam" },
    { value: "singapore", label: "Singapore" },
  ];

  const balanceOptions = [
    { value: "0-100", label: "0 - 100 SGD" },
    { value: "100-1000", label: "100 - 1000 SGD" },
  ];

  const typeOptions = [
    { value: "individual", label: "Individual" },
    { value: "organization", label: "Organization" },
  ];

  const columns = [
    {
      label: "User ID",
      key: "id",
      className: "ps-4",
      style: { width: "80px" },
    },
    {
      label: "Name",
      key: "name",
      className: "ps-2",
      render: (item) => <div className="text-black fw-bold">{item.name}</div>,
    },
    {
      label: "Customer type",
      key: "type",
      className: "ps-4",
      render: (item) => (
        <Badge
          className="rounded-pill px-3 py-1 fw-medium"
          bg={item.type === "Organization" ? "secondary" : "primary"}
          style={{
            fontSize: "11px",
            border: "none",
          }}
        >
          {item.type}
        </Badge>
      ),
    },
    { label: "Email", key: "email", className: "ps-4" },
    { label: "Phone number", key: "phone", className: "ps-4" },
    { label: "ID card no", key: "idCard", className: "ps-4" },
    {
      label: "Available balance",
      key: "availableBalance",
      className: "ps-4",
      cellStyle: () => ({ whiteSpace: "pre-line" }),
    },
    {
      label: "Pending balance",
      key: "pendingBalance",
      className: "ps-4",
      cellStyle: () => ({ whiteSpace: "pre-line" }),
    },
    {
      label: "Status",
      key: "status",
      className: "ps-2",
      render: (item) => (
        <Badge
          bg="none"
          className="rounded-2 py-1 px-3 fs-12 fw-medium"
          style={{
            backgroundColor: "#E1F9ED",
            color: "#28C76F",
            minWidth: "80px",
          }}
        >
          {item.status === "ACTIVATED" ? "Activated" : item.status}
        </Badge>
      ),
    },
    {
      label: "KYC Status",
      key: "kycStatus",
      className: "ps-2",
      render: (item) => (
        <Badge
          bg="none"
          className="rounded-2 py-1 px-3 fs-12 fw-medium"
          style={{
            backgroundColor:
              item.kycStatus === "APPROVED" ? "#E1F9ED" : "#FFF3E0",
            color: item.kycStatus === "APPROVED" ? "#28C76F" : "#FF9F43",
            minWidth: "80px",
          }}
        >
          {item.kycStatus === "APPROVED" ? "Approved" : "Pending"}
        </Badge>
      ),
    },
    {
      label: "Created Time",
      key: "createdTime",
      className: "ps-2",
      cellStyle: () => ({ whiteSpace: "pre-line" }),
    },
    {
      label: "Actions",
      className: "ps-4",
      render: (item) => (
        <div
          className="cursor-pointer text-muted hover-primary"
          onClick={() => {
            navigate(`/customer-details/${item.id}`);
          }}
        >
          <i className="far fa-eye text-secondary fs-16"></i>
        </div>
      ),
    },
  ];

  const mockData = [
    {
      id: "10844",
      name: "SparkMinds Technology Pte Ltd",
      type: "Organization",
      email: "checkpast12month@yopmail.com",
      phone: "+84 765161894",
      idCard: "S1234567A013",
      availableBalance: "200 SGD\n0 USD",
      pendingBalance: "0 SGD\n0 USD",
      status: "ACTIVATED",
      kycStatus: "APPROVED",
      createdTime: "06/03/2026\n18:23:59",
    },
    {
      id: "10843",
      name: "Thuy Nga Phan",
      type: "Individual",
      email: "individual@yopmail.com",
      phone: "+84 789908092",
      idCard: "check12month",
      availableBalance: "969 SGD\n0 USD",
      pendingBalance: "7,031.05 SGD\n0 USD",
      status: "ACTIVATED",
      kycStatus: "APPROVED",
      createdTime: "06/03/2026\n11:38:29",
    },
    {
      id: "10842",
      name: "idjaoida",
      type: "Organization",
      email: "judhuiajhdoa@yopmail.com",
      phone: "+65 93213213",
      idCard: "154651651",
      availableBalance: "-",
      pendingBalance: "-",
      status: "ACTIVATED",
      kycStatus: "PENDING",
      createdTime: "05/03/2026\n10:41:31",
    },
  ];

  const [filteredData, setFilteredData] = useState(mockData);

  const handleSearch = () => {
    let result = mockData.filter((item) => {
      const matchName = name
        ? item.name.toLowerCase().includes(name.toLowerCase())
        : true;
      const matchId = idCard
        ? item.idCard.toLowerCase().includes(idCard.toLowerCase())
        : true;
      const matchPhone = phone
        ? item.phone.toLowerCase().includes(phone.toLowerCase())
        : true;
      const matchEmail = email
        ? item.email.toLowerCase().includes(email.toLowerCase())
        : true;
      const matchType = customerType
        ? item.type.toLowerCase() === customerType.value.toLowerCase()
        : true;

      return matchName && matchId && matchPhone && matchEmail && matchType;
    });
    setFilteredData(result);
  };

  const handleReset = () => {
    setName("");
    setIdCard("");
    setPhone("");
    setEmail("");
    setNationality(null);
    setWalletBalance(null);
    setCustomerType(null);
    setFilteredData(mockData);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold text-black mb-0">Customers</h2>
        <div className="d-flex gap-2">
          <CommonButton
            variant="primary"
            className="d-flex align-items-center"
            onClick={() => setShowIndividualModal(true)}
          >
            <i className="fas fa-plus me-2"></i> Create individual customer
          </CommonButton>
          <CommonButton
            variant="outline"
            className="d-flex align-items-center"
            onClick={() => setShowOrganizationModal(true)}
          >
            <i className="fas fa-building me-2"></i> Create organization
            customer
          </CommonButton>
        </div>
      </div>

      <Card className="border-0 shadow-sm rounded-4 mb-4">
        <Card.Body className="p-4">
          <Row className="g-3 mb-4">
            <Col xl={3} lg={4} md={6}>
              <CommonInput
                placeholder="Enter name"
                value={name}
                label="Name"
                onChange={(e) => setName(e.target.value)}
              />
            </Col>
            <Col xl={3} lg={4} md={6}>
              <CommonInput
                placeholder="Enter ID card"
                value={idCard}
                label="ID card no"
                onChange={(e) => setIdCard(e.target.value)}
              />
            </Col>
            <Col xl={3} lg={4} md={6}>
              <CommonSelect
                label="Nationality"
                placeholder="Select nationality"
                options={nationalityOptions}
                value={nationality}
                onChange={setNationality}
              />
            </Col>
            <Col xl={3} lg={4} md={6}>
              <CommonInput
                placeholder="Enter phone number"
                value={phone}
                label="Phone number"
                onChange={(e) => setPhone(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="g-3 align-items-end">
            <Col xl={3} lg={4} md={6}>
              <CommonInput
                placeholder="Enter email"
                value={email}
                label="Email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </Col>
            <Col xl={3} lg={4} md={6}>
              <CommonSelect
                placeholder="Select customer type"
                options={typeOptions}
                label="Customer type"
                value={customerType}
                onChange={setCustomerType}
              />
            </Col>
            <Col xl={3} lg={4} md={6}>
              <CommonSelect
                label="Wallet balance"
                placeholder="Select wallet balance"
                options={balanceOptions}
                value={walletBalance}
                onChange={setWalletBalance}
              />
            </Col>
            <Col xl={3} lg={12} className="d-flex gap-2">
              <CommonButton
                variant="outline"
                onClick={handleReset}
                className="p-0 d-flex align-items-center justify-content-center"
                style={{ width: "50px", height: "50px", minWidth: "50px" }}
              >
                <i className="flaticon-381-repeat-1"></i>
              </CommonButton>
              <CommonButton
                onClick={handleSearch}
                className="p-0 d-flex align-items-center justify-content-center"
                style={{ width: "50px", height: "50px", minWidth: "50px" }}
              >
                <i className="flaticon-381-search-1 fs-20"></i>
              </CommonButton>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
        <div className="card-body">
          <DataTable
            data={filteredData}
            columns={columns}
            totalItems={filteredData.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            paginate={setCurrentPage}
            minWidth="100%"
          />
        </div>
      </div>

      <IndividualCustomerModal
        show={showIndividualModal}
        onHide={() => setShowIndividualModal(false)}
      />
      <OrganizationCustomerModal
        show={showOrganizationModal}
        onHide={() => setShowOrganizationModal(false)}
      />
      {/* CustomerDetailsModal removed in favor of page navigation */}
    </div>
  );
};

export default CustomerList;
